import { withContext } from 'components/withContext';
import { createContext } from 'react';

const SystemContext = createContext();
const SystemConsumer = withContext(SystemContext, 'system');

export { SystemContext, SystemConsumer };
